import { TOKEN_KEY } from './constants';
import { GenericResponse } from '@/lib/common/types';
import { AxiosInstance, AxiosRequestConfig } from 'axios';

export default class AuthService {
  private token = '';
  private order = '';
  private photomarketVard = '';
  constructor(private readonly $axios: AxiosInstance) {
  }

  public async tryToLogin(order: string, pincode: string): Promise<boolean> {
    try {
      const params = { order, pincode };
      const loginResultData = await this.$axios.post<GenericResponse>('auth/login', params);
      const { data: loginResult } = loginResultData;
      if (loginResult && loginResult.status) {
        localStorage.setItem(TOKEN_KEY, loginResult.data);
        this.token = loginResult.data;
        this.order = order;
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  public resetToken(): void {
    this.token = '';
  }

  public async checkAuth(): Promise<boolean> {
    if (this.token) {
      return true;
    }
    const tokenFromStorage = localStorage.getItem(TOKEN_KEY);
    if (!tokenFromStorage) {
      return false;
    }

    const loginResultData = await this.$axios.post('auth/check', null, {
      ...this.signRequest(tokenFromStorage),
    });
    const { data: loginResult } = loginResultData;
    if (loginResult && loginResult.status) {
      this.token = loginResult.data.token;
      this.order = loginResult.data.order;
      return true;
    }
    return false;
  }

  public logout(): void {
    this.token = '';
    this.order = '';
    localStorage.removeItem(TOKEN_KEY);
  }

  public signRequest(token: string = this.token): AxiosRequestConfig {
    return {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    };
  }

  public getOrder(): string {
    return this.order;
  }

  public getToken(): string {
    return this.token;
  }
}
